export const salesDemoConstants = {
    SALES_DEMO_CHECK_PENDING: 'SALES_DEMO_CHECK_PENDING',
    SALES_DEMO_CHECK_FULFILLED: 'SALES_DEMO_CHECK_FULFILLED',
    SALES_DEMO_CHECK_REJECTED: 'SALES_DEMO_CHECK_REJECTED',
    SALES_DEMO_LIST_PENDING: 'SALES_DEMO_LIST_PENDING',
    SALES_DEMO_LIST_FULFILLED: 'SALES_DEMO_LIST_FULFILLED',
    SALES_DEMO_LIST_REJECTED: 'SALES_DEMO_LIST_REJECTED',
    SALES_DEMO_START_PENDING: 'SALES_DEMO_START_PENDING',
    SALES_DEMO_START_FULFILLED: 'SALES_DEMO_START_FULFILLED',
    SALES_DEMO_START_REJECTED: 'SALES_DEMO_START_REJECTED',
    SALES_DEMO_STATUS_PENDING: 'SALES_DEMO_STATUS_PENDING',
    SALES_DEMO_STATUS_FULFILLED: 'SALES_DEMO_STATUS_FULFILLED',
    SALES_DEMO_STATUS_REJECTED: 'SALES_DEMO_STATUS_REJECTED',
    SALES_DEMO_SEARCH_PENDING: 'SALES_DEMO_SEARCH_PENDING',
    SALES_DEMO_SEARCH_FULFILLED: 'SALES_DEMO_SEARCH_FULFILLED',
    SALES_DEMO_SEARCH_REJECTED: 'SALES_DEMO_SEARCH_REJECTED',
    SALES_DEMO_SEARCH_CLEAR: 'SALES_DEMO_SEARCH_CLEAR',
    SALES_DEMO_CLEAR: 'SALES_DEMO_CLEAR',
};
